<template>
  <v-card class="ma-0 pa-0" fluid v-resize="onResize">
    <v-toolbar flat>
      <v-col xs="3" sm="2" md="2" lg="2" xl="2" class="pl-0 mt-7">
        <v-menu
          offset-y
          nudge-top="25"
          :close-on-content-click="false"
          bottom
          v-model="priceZoneSelectMenu">
          <template #activator="{ on }">
            <v-text-field
              :disabled="!selected.length || !_.isEmpty(selectedStores)"
              readonly
              v-on="on"
              :class="body"
              outlined
              dense
              background-color="input"
              label="Select By Price Zones"
              prepend-inner-icon="mdi-order-bool-ascending-variant"
              :value="formattedSelectedZones"
              clearable
              @click:clear=";(selectedPriceZones = []), (selected = [])">
            </v-text-field>
          </template>
          <v-card style="height: 480px; max-width: 300px; overflow-y: auto">
            <v-container class="grey lighten-3 pa-0" fluid>
              <v-card-title class="text-subtitle-1 font-weight-light">
                Selected Price Zones
                <v-spacer />
                <v-btn small icon @click="priceZoneSelectMenu = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider />
              <section
                class="white px-2 pt-1"
                style="height: 120px; overflow-y: auto">
                <v-row align="center" justify="center" dense>
                  <span class="text-caption" v-if="!selectedPriceZones.length"
                    >No Prices Zones Selected</span
                  >
                  <v-col
                    style="max-width: 100px"
                    class="px-0 ma-0"
                    cols="4"
                    v-for="(priceZone, index) in selectedPriceZones"
                    :key="index">
                    <v-chip close @click:close="selectPriceZones(priceZone)">
                      {{ priceZone.code }}
                    </v-chip>
                  </v-col>
                </v-row>
              </section>
              <v-text-field
                :class="body"
                hide-details
                outlined
                background-color="white"
                class="rounded-0 mb-0"
                dense
                prepend-inner-icon="mdi-filter-outline"
                label="Filter Price Zones"
                v-model="priceZoneFilter"
                clearable />
              <section class="pa-0">
                <v-list
                  style="height: 205px; overflow-y: auto"
                  dense
                  class="py-0 px-">
                  <template v-for="(priceZone, index) in filteredPriceZones">
                    <v-list-item
                      :key="index"
                      :class="
                        selectedPriceZones.some(s => s == priceZone)
                          ? 'itemSelect'
                          : ''
                      "
                      class="text-body-2"
                      @click="selectPriceZones(priceZone)">
                      <span
                        :class="
                          selectedPriceZones.some(s => s == priceZone)
                            ? 'primary--text'
                            : ''
                        ">
                        {{ priceZone.code }}
                      </span>
                    </v-list-item>
                  </template>
                </v-list>
              </section>
            </v-container>
            <v-divider />
            <v-card-actions class="grey lighten-3">
              <v-spacer />
              <v-btn :class="body" text rounded @click="selectedPriceZones = []"
                >Clear</v-btn
              >
              <v-btn
                :disabled="!selectedPriceZones.length"
                :class="body"
                class="primary white--text"
                rounded
                @click="getSelectedVariancesByZone"
                >Apply
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>

      <v-col xs="3" sm="2" md="2" lg="2" xl="2" class="pl-0 mt-7">
        <v-menu
          offset-y
          nudge-top="25"
          :close-on-content-click="false"
          bottom
          v-model="storeSelectMenu">
          <template #activator="{ on }">
            <v-text-field
              :disabled="!selected.length || !_.isEmpty(selectedPriceZones)"
              readonly
              v-on="on"
              :class="body"
              outlined
              dense
              background-color="input"
              label="Select By Store Numbers"
              prepend-inner-icon="mdi-order-bool-ascending-variant"
              :value="formattedSelectedStores"
              clearable
              @click:clear=";(selectedStores = []), (selected = [])">
            </v-text-field>
          </template>
          <v-card style="height: 480px; max-width: 300px; overflow-y: auto">
            <v-container class="grey lighten-3 pa-0" fluid>
              <v-card-title class="text-subtitle-1 font-weight-light">
                Selected Stores
                <v-spacer />
                <v-btn small icon @click="storeSelectMenu = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider />
              <section
                class="white px-2 pt-1"
                style="height: 120px; overflow-y: auto">
                <v-row align="center" justify="center" dense>
                  <span class="text-caption mr-2" v-if="!selectedStores.length"
                    >No Stores Selected</span
                  >
                  <v-col
                    style="max-width: 75px"
                    class="px-0 ma-0"
                    cols="4"
                    v-for="(store, index) in selectedStores"
                    :key="index">
                    <v-chip close @click:close="selectStores(store)">
                      {{ store.store_number }}
                    </v-chip>
                  </v-col>
                </v-row>
              </section>
              <v-text-field
                :class="body"
                hide-details
                outlined
                background-color="white"
                class="rounded-0 mb-0"
                dense
                prepend-inner-icon="mdi-filter-outline"
                label="Filter Stores"
                v-model="storeFilter"
                clearable />
              <section class="pa-0">
                <v-list
                  style="height: 205px; overflow-y: auto"
                  dense
                  class="py-0 px-">
                  <template v-for="(store, index) in filteredStores">
                    <v-list-item
                      :key="index"
                      :class="
                        selectedStores.some(s => s == store) ? 'itemSelect' : ''
                      "
                      class="text-body-2"
                      @click="selectStores(store)">
                      <span
                        :class="
                          selectedStores.some(s => s == store)
                            ? 'primary--text'
                            : ''
                        ">
                        {{ store.store_number }}
                      </span>
                    </v-list-item>
                  </template>
                </v-list>
              </section>
            </v-container>
            <v-divider />
            <v-card-actions class="grey lighten-3">
              <v-spacer />
              <v-btn :class="body" text rounded @click="selectedStores = []"
                >Clear</v-btn
              >
              <v-btn
                :disabled="!selectedStores.length"
                :class="body"
                class="primary white--text"
                rounded
                @click="getSelectedVariancesByStore"
                >Apply
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-col xs="3" sm="5" md="4" lg="3" xl="3" class="pl-0 mt-7">
        <v-text-field
          :disabled="!items.length"
          :class="body"
          outlined
          dense
          background-color="input"
          label="Filter Items"
          prepend-inner-icon="mdi-filter-outline"
          v-model="search" />
      </v-col>
      <v-spacer />
      <v-menu
        open-on-hover
        transition="slide-y-transition"
        nudge-left="40"
        offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="
              !contract.store_type ||
              readonly ||
              !savedContract ||
              !itemsSelected
            "
            :class="body"
            class="grey lighten-3 ml-2"
            rounded
            v-bind="attrs"
            v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>Actions
          </v-btn>
        </template>
        <v-card class="mx-auto" max-width="300">
          <v-list dense>
            <v-list-item
              v-for="(action, i) in actions"
              :key="i"
              :disabled="action.disabled"
              @click=";(component = action.component), (modal = true)">
              <v-list-item-action :disabled="action.disabled">
                <v-icon>{{ action.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content class="mr-3">
                <v-list-item-title :class="body">{{
                  action.label
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      <v-btn
        :disabled="
          !contract.store_type || readonly || newItemContract || !savedContract
        "
        :class="body"
        class="primary mx-2"
        rounded
        @click=";(component = 'ItemSearch'), (modal = true)">
        <v-icon left>mdi-magnify</v-icon>Search
      </v-btn>
      <v-btn
        :disabled="
          !contract.store_type ||
          readonly ||
          !savedContract ||
          selected.length > 0 ||
          selectedVariances.length > 0
        "
        :class="body"
        class="primary"
        rounded
        @click=";(component = 'ItemNew'), (modal = true)">
        <v-icon left>mdi-star-outline</v-icon>New Item
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-data-table
      :items="items"
      :headers="itemHeaders"
      :height="tableHeight"
      class="table-striped rounded-0"
      :expanded.sync="expanded"
      :item-class="itemRowBackground"
      :footer-props="{ 'items-per-page-options': pageSizes }"
      :search="search"
      v-model="selected"
      no-data-text="No Items Added to Contract"
      show-select
      fixed-header
      single-expand
      item-key="item_uuid"
      sort-by="item_exists"
      dense
      @click:row="expandToggle"
      style="cursor: pointer">
      <template #[`header.data-table-select`]="{ on, props }">
        <v-simple-checkbox :ripple="false" v-on="on" v-bind="props" dark />
      </template>

      <!--##### Hidden due to Vendor confusion #####-->
      <!-- <template #[`item.variances_selected`]="{ item }">
        <v-tooltip top>
          <template #activator="{ on }">
            <v-chip v-on="on" small outlined>
              <span v-if="selectedVariances.filter(s => s.upc == item.upc).length" class="accent--text">
                {{selectedVariances.filter(s => s.upc == item.upc).length}}
              </span>
              <v-icon v-else small color="red">mdi-cancel</v-icon>
            </v-chip>
          </template>
          <span>{{selectedVariances.filter(s => s.upc == item.upc).length ? 'Stores Selected' : 'No Stores Selected'}}</span>
        </v-tooltip>
      </template> -->

      <template #[`item.item_exists`]="{ item }">
        <v-tooltip v-if="item.item_exists == false" top>
          <template #activator="{ on }">
            <v-icon v-on="on" color="yellow darken-2">
              {{ 'mdi-star' }}
            </v-icon>
          </template>
          <span>New</span>
        </v-tooltip>
      </template>

      <template #[`item.cost_change`]="{ item }">
        <v-tooltip
          v-if="item.variances.some(variance => variance.cost_change)"
          top>
          <template #activator="{ on }">
            <v-icon v-on="on" color="success">mdi-currency-usd-off</v-icon>
          </template>
          <span>Cost Change</span>
        </v-tooltip>
      </template>

      <template #[`item.pack`]="{ item }">
        {{ item.pack }} / {{ item.size }}
      </template>

      <template #[`item.plg_ap_number`]="{ item }">
        {{ item.plg_ap_number | empty }}
      </template>

      <template #[`item.ppu_name`]="{ item }">
        {{ item.ppu_name | empty }}
      </template>

      <template #[`item.ppu_code`]="{ item }">
        {{ item.ppu_code | empty }}
      </template>

      <template #[`expanded-item`]="{ headers, item }">
        <td :colspan="headers.length" class="ma-0 pa-0">
          <v-data-table
            :headers="varianceHeaders"
            :height="expandedRowHeight(item)"
            :item-class="selectedRowBackground"
            :items-per-page="100"
            :items="item.variances"
            :class="table"
            class="rounded-0 ma-0 pa-0"
            dense
            fixed-header
            hide-default-footer
            item-key="variance_uuid"
            show-select
            sort-by="store_number"
            v-model="selectedVariances">
            <template #[`item.store_number`]="{ item }">
              <v-tooltip top>
                <template #activator="{ on }">
                  <a
                    v-on="on"
                    class="primary--text"
                    @click="
                      ;(storeNumber = item.store_number),
                        (component = 'StoreInfo'),
                        (modal = true)
                    ">
                    #{{ item.store_number }}
                  </a>
                </template>
                <span>View Store Info</span>
              </v-tooltip>
            </template>

            <!-- Item Variance General Headers -->
            <!-- <template #[`header.store_number`]="{ header }">
            <span style="z-index:-1;" class="noWrap">{{ header.text }}</span>
          </template>
          <template #[`header.price_zone`]="{ header }">
            <span class="noWrap">{{ header.text }}</span>
          </template>
          <template #[`header.case_cost`]="{ header }">
            <span class="noWrap">{{ header.text}}</span>
          </template>
          <template #[`header.unit_cost`]="{ header }">
            <span class="noWrap">{{ header.text}}</span>
          </template>
          <template #[`header.off_invoice_amount`]="{ header }">
            <span class="noWrap">{{ header.text}}</span>
          </template>
          <template #[`header.deal_unit_cost`]="{ header }">
            <span class="noWrap">{{ header.text}}</span>
          </template>
          <template #[`header.regular_retail`]="{ header }">
            <span class="noWrap">{{ header.text}}</span>
          </template>
          <template #[`header.regular_retail_percentage`]="{ header }">
            <span class="noWrap">{{ header.text}}</span>
          </template>
          <template #[`header.pre_priced_value`]="{ header }">
            <span class="noWrap">{{ header.text }}</span>
          </template>
          <template #[`header.kvi_group_name`]="{ header }">
            <span class="noWrap">{{ header.text }}</span>
          </template>
          <template #[`header.pre_priced`]="{ header }">
            <span class="noWrap">{{ header.text }}</span>
          </template>
          <template #[`header.included_flag`]="{ header }">
            <span class="noWrap">{{ header.text }}</span>
          </template> -->

            <!-- Item Variance TPR Contract Headers -->
            <template #[`header.off_invoice_tpr`]="{ header }">
              <span v-if="tprContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.epay_tpr`]="{ header }">
              <span v-if="tprContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.scan_tpr`]="{ header }">
              <span v-if="tprContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.billback_tpr`]="{ header }">
              <span v-if="tprContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.tpr_deal_unit_cost`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.tpr_retail`]="{ header }">
              <span v-if="tprContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.tpr_retail_percentage`]="{ header }">
              <span v-if="tprContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.net_tpr_unit_cost`]="{ header }">
              <span v-if="tprContract" class="noWrap">{{ header.text }}</span>
            </template>

            <!-- Item Variance Ad Contract Headers -->
            <template #[`header.off_invoice_ad`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.epay_ad`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.scan_ad`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.billback_ad`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.ad_deal_unit_cost`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.ad_retail`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.ad_retail_percentage`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>
            <template #[`header.net_ad_unit_cost`]="{ header }">
              <span v-if="adContract" class="noWrap">{{ header.text }}</span>
            </template>

            <template #[`header.general_col_divider`]="{}">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn
                    :class="body"
                    v-on="on"
                    style="width: 100px"
                    class="primary--text font-weight-medium text-body-2 ml-8"
                    text
                    small
                    @click="column1 = !column1">
                    <v-icon v-if="column1" left> mdi-chevron-left </v-icon>
                    General
                    <v-icon v-if="!column1" right> mdi-chevron-right </v-icon>
                  </v-btn>
                </template>
                <span>{{ column1 ? 'Collapse' : 'Expand' }}</span>
              </v-tooltip>
            </template>
            <template #[`header.tpr_col_divider`]="{}">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn
                    :class="body"
                    v-on="on"
                    style="width: 100px"
                    class="primary--text font-weight-medium text-body-2"
                    text
                    small
                    @click="column2 = !column2">
                    <v-icon v-if="column2" left> mdi-chevron-left </v-icon>
                    TPR
                    <v-icon v-if="!column2" right> mdi-chevron-right </v-icon>
                  </v-btn>
                </template>
                <span>{{ column2 ? 'Collapse' : 'Expand' }}</span>
              </v-tooltip>
            </template>
            <template #[`header.ad_col_divider`]="{}">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-btn
                    :class="body"
                    v-on="on"
                    style="width: 100px"
                    class="primary--text font-weight-medium text-body-2 ml-8"
                    text
                    small
                    @click="column3 = !column3">
                    <v-icon v-if="column3" left> mdi-chevron-left </v-icon>
                    Ad
                    <v-icon v-if="!column3" right> mdi-chevron-right </v-icon>
                  </v-btn>
                </template>
                <span>{{ column3 ? 'Collapse' : 'Expand' }}</span>
              </v-tooltip>
            </template>

            <template #[`item.divider`]="{}">
              <v-divider vertical />
            </template>
            <template #[`item.general_col_divider`]="{}">
              <v-divider vertical />
            </template>
            <template #[`item.tpr_col_divider`]="{}">
              <v-divider vertical />
            </template>
            <template #[`item.ad_col_divider`]="{}">
              <v-divider vertical />
            </template>

            <!-- Item Variance General Columns -->
            <template #[`item.case_cost`]="{ item }">
              <td v-if="column1" class="noWrap">
                ${{ item.case_cost | format }}
              </td>
            </template>
            <template #[`item.cost_change_value`]="{ item }">
              <td v-if="column1" class="noWrap">
                ${{ item.cost_change_value | format }}
              </td>
            </template>
            <template #[`item.pricing_rules`]="{ item }">
              <v-checkbox
                :readonly="readonly"
                @change="updateItems"
                inset
                style="height: 20px"
                class="mt-0 ml-6 pa-0"
                color="orange"
                v-model="item.pricing_rules" />
            </template>
            <template #[`item.cost_change`]="{ item }">
              <v-checkbox
                :readonly="readonly"
                @change="updateItems"
                inset
                style="height: 20px"
                class="mt-0 ml-6 pa-0"
                color="orange"
                v-model="item.cost_change" />
            </template>

            <template #[`item.regular_retail`]="{ item }">
              <td v-if="column1" class="noWrap">
                ${{ item.regular_retail | format }}
              </td>
            </template>
            <template #[`item.regular_retail_percentage`]="{ item }">
              <td v-if="column1" class="noWrap">
                {{ item.regular_retail_percentage | format }}%
              </td>
            </template>
            <template #[`item.off_invoice_amount`]="{ item }">
              <td v-if="column1" class="noWrap">
                ${{ item.off_invoice_amount | format }}
              </td>
            </template>
            <template #[`item.deal_unit_cost`]="{ item }">
              <td v-if="column1" class="noWrap">
                ${{ item.deal_unit_cost | format }}
              </td>
            </template>
            <template #[`item.unit_cost`]="{ item }">
              <td v-if="column1" class="noWrap">
                ${{ item.unit_cost | format }}
              </td>
            </template>
            <template #[`item.pre_priced_value`]="{ item }">
              <td v-if="column1" class="noWrap">
                ${{ item.pre_priced_value | format }}
              </td>
            </template>
            <template #[`item.kvi_group_name`]="{ item }">
              <td v-if="column1" class="noWrap">
                {{ item.kvi_group_name | empty }}
              </td>
            </template>
            <template #[`item.pre_priced`]="{ item }">
              <v-checkbox
                v-if="column4"
                :readonly="readonly"
                @change="updateItems"
                inset
                style="height: 20px"
                class="mt-0 ml-6 pa-0"
                color="orange"
                v-model="item.pre_priced" />
            </template>
            <template #[`item.included_flag`]="{ item }">
              <v-checkbox
                v-if="column4"
                :readonly="readonly"
                @change="updateItems"
                inset
                style="height: 20px"
                class="mt-0 ml-6 pa-0"
                color="orange"
                v-model="item.included_flag" />
            </template>

            <!-- Item Variance TPR Contract Columns -->
            <template #[`item.off_invoice_tpr`]="{ item }">
              <td v-if="tprContract && column2" class="noWrap">
                ${{ item.tpr_off_invoice_amount | format }}
              </td>
            </template>
            <template #[`item.epay_tpr`]="{ item }">
              <td v-if="tprContract && column2" class="noWrap">
                ${{ item.epay_tpr | format }}
              </td>
            </template>
            <template #[`item.scan_tpr`]="{ item }">
              <td v-if="tprContract && column2" class="noWrap">
                ${{ item.scan_tpr | format }}
              </td>
            </template>
            <template #[`item.billback_tpr`]="{ item }">
              <td v-if="tprContract && column2" class="noWrap">
                ${{ item.billback_tpr | format }}
              </td>
            </template>
            <template #[`item.tpr_retail`]="{ item }">
              <td v-if="tprContract && column2" class="noWrap">
                {{ item.tpr_multiple }} @ ${{ item.tpr_retail | format }}
              </td>
            </template>
            <template #[`item.tpr_retail_percentage`]="{ item }">
              <td v-if="tprContract && column2" class="noWrap">
                {{ item.tpr_retail_percentage | format }}%
              </td>
            </template>
            <template #[`item.net_tpr_unit_cost`]="{ item }">
              <td v-if="tprContract && column2" class="noWrap">
                ${{ item.net_tpr_unit_cost | format }}
              </td>
            </template>

            <!-- Item Variance Ad Contract Columns -->
            <template #[`item.off_invoice_ad`]="{ item }">
              <td v-if="adContract && column3" class="noWrap">
                ${{ item.ad_off_invoice_amount | format }}
              </td>
            </template>
            <template #[`item.epay_ad`]="{ item }">
              <td v-if="adContract && column3" class="noWrap">
                ${{ item.epay_ad | format }}
              </td>
            </template>
            <template #[`item.scan_ad`]="{ item }">
              <td v-if="adContract && column3" class="noWrap">
                ${{ item.scan_ad | format }}
              </td>
            </template>
            <template #[`item.billback_ad`]="{ item }">
              <td v-if="adContract && column3" class="noWrap">
                ${{ item.billback_ad | format }}
              </td>
            </template>
            <template #[`item.ad_retail`]="{ item }">
              <td v-if="adContract && column3" class="noWrap">
                {{ item.ad_multiple }} @ ${{ item.ad_retail | format }}
              </td>
            </template>
            <template #[`item.ad_retail_percentage`]="{ item }">
              <td v-if="adContract && column3" class="noWrap">
                {{ item.ad_retail_percentage | format }}%
              </td>
            </template>
            <template #[`item.net_ad_unit_cost`]="{ item }">
              <td v-if="adContract && column3" class="noWrap">
                ${{ item.net_ad_unit_cost | format }}
              </td>
            </template>
          </v-data-table>
          <v-divider />
        </td>
      </template>
    </v-data-table>

    <Component
      :contract="contract"
      :is="component"
      :items="items"
      :key="componentKey"
      :newItem="!selected.length && !selectedVariances.length"
      :saving="saving"
      :selected="selected"
      :selectedVariance="selectedVariance"
      :selectedVariances="selectedVariances"
      :storeNumber="storeNumber"
      :value.sync="modal"
      :vendor="vendor"
      @add="addItems"
      @remove="removeItems"
      @update="updateItems" />
  </v-card>
</template>

<script>
import { table } from '@/mixins/table-config'
import { displayHelpers } from '@/mixins/display-helpers'
import { format } from '@/mixins/format'
import { mapState } from 'vuex'

export default {
  components: {
    ItemSearch: () => import('@/components/items/ItemSearch'),
    ItemNew: () => import('@/components/items/ItemNew'),
    ItemEdit: () => import('@/components/items/ItemEdit'),
    ItemDelete: () => import('@/components/items/ItemDelete'),
    ItemStoreMgmt: () => import('@/components/items/ItemStoreMgmt'),
    StoreInfo: () => import('@/components/stores/StoreInfo'),
    Overlay: () => import('@/components/shared/Overlay')
  },

  mixins: [table, format, displayHelpers],

  props: {
    contract: Object,
    isExistingContract: Boolean,
    readonly: Boolean,
    vendor: Object,
    tab: Number
  },

  data: () => ({
    alertComponent: '',
    alertModal: false,
    column1: true,
    column2: true,
    column3: true,
    column4: true,
    component: '',
    componentKey: 0,
    expanded: [],
    expandedTableHeight: '',
    items: [],
    menu: false,
    modal: false,
    pageSizes: [250, 100, 50],
    saving: false,
    search: '',
    selected: [],
    selectedPriceZones: [],
    selectedStores: [],
    selectedVariance: {},
    selectedVariances: [],
    storeFilter: '',
    storeNumber: '',
    storeSelectMenu: false,
    tableHeight: '',
    priceZoneFilter: '',
    priceZoneSelectMenu: false,
    lastSelectedRow: ''
  }),

  computed: {
    priceZones() {
      if (this.items.length > 0)
        return this._.uniqBy(
          this.items.reduce((acc, item) => {
            item.variances.map(value => {
              acc.push({
                code: value.price_zone
              })
            })
            return acc
          }, []),
          'code'
        ).sort()
      else {
        return []
      }
    },

    storeNumbers() {
      if (this.items.length > 0) {
        return this._.uniqBy(
          this._.orderBy(
            this.items.reduce((acc, item) => {
              item.variances.map(v => {
                acc.push({
                  store_number: parseInt(v.store_number)
                })
              })
              return acc
            }, []),
            ['store_number'],
            ['asc']
          ),
          'store_number'
        ).sort((a, b) => a - b)
      } else {
        return []
      }
    },

    formattedSelectedStores() {
      return this.selectedStores.length
        ? `${this.selectedStores.length} Selected`
        : []
    },

    formattedSelectedZones() {
      return this.selectedPriceZones.length
        ? `${this.selectedPriceZones.length} Selected`
        : []
    },

    filteredPriceZones() {
      if (this.priceZoneFilter) {
        return this.priceZones.filter(value => {
          if (
            value.code
              .toLowerCase()
              .includes(this.priceZoneFilter.toLowerCase())
          ) {
            // if (value.code.to == this.zoneFilter) {
            return value
          }
        })
      } else {
        return this.priceZones
      }
    },

    filteredStores() {
      if (this.storeFilter) {
        return this.storeNumbers.filter(value => {
          if (value.store_number == this.storeFilter) {
            return value
          }
        })
      } else {
        return this.storeNumbers
      }
    },

    selectedVariancesUPCs() {
      return this._.uniq(this.selectedVariances.map(v => v.upc))
    },

    savedContract() {
      return !this._.isEmpty(this.contract.contract_uuid)
    },

    itemsSelected() {
      return this.selected.length > 0 || this.selectedVariances.length > 0
    },

    ...mapState(['allStores', 'addedItems', 'contractTypes', 'storeTypes']),

    actions() {
      return [
        {
          label: 'Edit Selected',
          component: 'ItemEdit',
          icon: 'mdi-pencil-outline',
          disabled: !this.selected.length && !this.selectedVariances.length
        },
        {
          label: 'Delete Selected',
          component: 'ItemDelete',
          icon: 'mdi-trash-can-outline',
          disabled: !this.selected.length
        }
      ]
    },

    adContract() {
      return this.contractTypes.some(
        type => type.active && type.contract_type === 'Ad'
      )
    },

    tprContract() {
      return this.contractTypes.some(
        type => type.active && type.contract_type === 'TPR'
      )
    },

    costChangeContract() {
      return this.contractTypes.some(
        type => type.active && type.contract_type === 'Cost Change'
      )
    },

    itemHeaders() {
      return [
        {
          sortable: false,
          value: 'data-table-select',
          class: 'accent white--text noWrap'
        },
        {
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: false,
          sortable: false,
          value: 'item_exists'
        },
        {
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: false,
          sortable: false,
          value: 'cost_change'
        },
        {
          text: 'UPC',
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: true,
          sortable: true,
          value: 'upc'
        },
        {
          text: 'Description',
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: true,
          sortable: true,
          value: 'description'
        },
        {
          text: 'Pack/Size',
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: true,
          sortable: true,
          value: 'pack'
        },
        {
          text: 'PLG AP Number',
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: true,
          sortable: true,
          value: 'plg_ap_number'
        },
        {
          text: 'PPU Name',
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: true,
          sortable: true,
          value: 'ppu_name'
        },
        {
          text: 'PPU Code',
          align: 'start',
          class: 'accent font-weight-medium white--text noWrap',
          filterable: true,
          sortable: true,
          value: 'ppu_code'
        }
      ]
    },

    varianceHeaders() {
      let headers = []

      const baseHeaders = [
        {
          sortable: false,
          value: 'data-table-select',
          class: 'grey lighten-2 font-weight-medium black--text noWrap'
        },
        {
          text: 'Include Store',
          align: this.column4 ? 'start' : ' d-none',
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          filterable: true,
          sortable: true,
          value: 'included_flag'
        },
        {
          text: 'Store Number',
          align: 'start',
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          filterable: true,
          sortable: true,
          value: 'store_number'
        },
        {
          text: 'Price Zone',
          align: 'start',
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          filterable: true,
          sortable: true,
          value: 'price_zone'
        },
        {
          text: 'Apply Pricing Rules',
          align: 'start',
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          filterable: true,
          sortable: true,
          value: 'pricing_rules'
        }
      ]

      const caseCost = {
        text: 'Case Cost',
        align: this.column1 ? 'start' : ' d-none',
        sortable: !this.costChangeContract,
        class: 'grey lighten-2 font-weight-medium black--text noWrap',
        value: 'case_cost'
      }

      const generalHeaders = [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'general_col_divider',
          class: 'px-0 grey lighten-2 font-weight-medium noWrap'
        },
        {
          text: 'Unit Cost',
          align: this.column1 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'unit_cost'
        },
        {
          text: 'Retail',
          align: this.column1 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'regular_retail'
        },
        {
          text: 'Retail Percentage',
          align: this.column1 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'regular_retail_percentage'
        },
        {
          text: 'Pre-Priced',
          align: this.column1 ? 'start' : ' d-none',
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          filterable: true,
          sortable: true,
          value: 'pre_priced'
        },
        {
          text: 'Pre-Priced Amount',
          align: this.column1 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'pre_priced_value'
        },
        {
          text: 'KVI Group Name',
          align: this.column1 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'kvi_group_name'
        }
      ]

      const costChangeHeaders = [
        {
          text: 'Cost Change',
          align: this.column1 ? 'start' : ' d-none',
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          filterable: true,
          sortable: true,
          value: 'cost_change'
        },
        {
          text: 'Cost Change Amount',
          align: this.column1 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'cost_change_value'
        }
      ]

      const tprHeaders = [
        {
          align: this.tprContract ? ' start' : ' d-none',
          sortable: false,
          value: 'tpr_col_divider',
          class: 'px-0 grey lighten-2 font-weight-medium noWrap'
        },
        {
          text: 'TPR Off Invoice',
          align: this.tprContract && this.column2 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'off_invoice_tpr'
        },
        {
          text: 'TPR ePay',
          align: this.tprContract && this.column2 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'epay_tpr'
        },
        {
          text: 'TPR Scan',
          align: this.tprContract && this.column2 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'scan_tpr'
        },
        {
          text: 'TPR Billback',
          align: this.tprContract && this.column2 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'billback_tpr'
        },
        {
          text: 'TPR Retail',
          align: this.tprContract && this.column2 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'tpr_retail'
        },
        {
          text: 'TPR Retail Percentage',
          align: this.tprContract && this.column2 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'tpr_retail_percentage'
        },
        {
          text: 'TPR Net Unit Cost',
          align: this.tprContract && this.column2 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'net_tpr_unit_cost'
        }
      ]

      const adHeaders = [
        {
          text: '',
          align: this.adContract ? ' start' : ' d-none',
          sortable: false,
          value: 'ad_col_divider',
          class: 'px-0 grey lighten-2 font-weight-medium noWrap'
        },
        {
          text: 'Ad Off Invoice',
          align: this.adContract && this.column3 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'off_invoice_ad'
        },
        {
          text: 'Ad ePay',
          align: this.adContract && this.column3 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'epay_ad'
        },
        {
          text: 'Ad Scan',
          align: this.adContract && this.column3 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'scan_ad'
        },
        {
          text: 'Ad BillBack',
          align: this.adContract && this.column3 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'billback_ad'
        },
        {
          text: 'Ad Retail',
          align: this.adContract && this.column3 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'ad_retail'
        },
        {
          text: 'Ad Retail Percentage',
          align: this.adContract && this.column3 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'ad_retail_percentage'
        },
        {
          text: 'Ad Net Unit Cost',
          align: this.adContract && this.column3 ? 'start' : ' d-none',
          sortable: true,
          class: 'grey lighten-2 font-weight-medium black--text noWrap',
          value: 'net_ad_unit_cost'
        },
        {
          text: '',
          align: 'start',
          sortable: false,
          value: '',
          class: 'grey lighten-2 font-weight-medium black--text noWrap'
        }
      ]

      headers = [...baseHeaders]

      if (this.costChangeContract || this.newItemContract) {
        generalHeaders.splice(1, 0, caseCost)
        headers.push(...generalHeaders)
      } else {
        generalHeaders.splice(1, 0, ...costChangeHeaders, caseCost)
        headers.push(...generalHeaders)
      }

      if (this.tprContract) {
        headers.push(...tprHeaders)
      }

      if (this.adContract) {
        headers.push(...adHeaders)
      }

      return headers
    },

    newItemContract() {
      return this.contractTypes.some(
        type => type.active && type.contract_type === 'New Item'
      )
    }
  },

  watch: {
    tab: {
      handler(newValue) {
        if (newValue === 1) {
          this.items = this.addedItems
          this.expanded = []
        }
      }
    },

    modal: {
      immediate: true,
      handler() {
        this.componentKey += 1
        if (!this.modal) {
          this.newItem = false
        }
      }
    },

    selected: {
      immediate: true,
      handler() {
        this.selectedVariances = this.selected.reduce((acc, item) => {
          const variances = item.variances
          acc.push(...variances)
          return acc
        }, [])
        if (this.selectedPriceZones.length) this.getSelectedVariancesByZone()
        if (this.selectedStores.length) this.getSelectedVariancesByStore()
      }
    }
  },

  created() {
    this.tableHeight = window.innerHeight - 337
    this.items = this.addedItems
    // if (this.isExistingContract) this.getItems()
  },

  beforeDestroy() {
    this.eventbus.$off('getItems')
  },

  methods: {
    onResize() {
      this.tableHeight = window.innerHeight - 337
    },

    expandToggle(item) {
      this.lastSelectedRow = item.upc
      if (this.expanded.length && this.expanded.some(o => o.upc === item.upc)) {
        var index = this.expanded.indexOf(item)
        this.expanded.splice(index, 1)
      } else {
        this.expanded = []
        this.expanded.push(item)
      }
    },

    expandedRowHeight(item) {
      let totalVariances = item.variances.length

      if (totalVariances * 70 < 390 && totalVariances > 1) {
        return item.variances.length * 70
      } else if (totalVariances < 2) {
        return totalVariances * 100
      } else {
        return 390
      }
    },

    itemRowBackground(item) {
      if (
        this.selected.length ||
        this.expanded.length ||
        this.selectedVariances.length ||
        this.lastSelectedRow
      ) {
        return this.selected.some(s => s.upc === item.upc) ||
          (this.selectedVariancesUPCs.includes(item.upc) &&
            !this.expanded.length)
          ? 'font-weight-medium'
          : item.upc === this.lastSelectedRow
          ? 'grey lighten-2'
          : 'white'
      }
    },

    selectedRowBackground(item) {
      return this.selectedVariances.some(
        s => s.variance_uuid === item.variance_uuid
      )
        ? 'font-weight-medium'
        : ''
    },

    selectPriceZones(priceZone) {
      if (
        this.selectedPriceZones.length &&
        this.selectedPriceZones.some(spz => spz.code === priceZone.code)
      ) {
        var index = this.selectedPriceZones.indexOf(priceZone)
        this.selectedPriceZones.splice(index, 1)
      } else {
        this.selectedPriceZones.push(priceZone)
        this.selectedPriceZones = this._.uniq(this.selectedPriceZones)
      }
    },

    selectStores(store) {
      if (
        this.selectedStores.length &&
        this.selectedStores.some(ss => ss.store_number === store.store_number)
      ) {
        var index = this.selectedStores.indexOf(store)
        this.selectedStores.splice(index, 1)
      } else {
        this.selectedStores.push(store)
        this.selectedStores = this._.uniq(this.selectedStores)
      }
    },

    async getItems() {
      let expanded = this.expanded
      try {
        const { data } = await this.$items.getItems(this.contract.contract_uuid)
        this.items = data
        const uniqueitems = this.items.map(item => {
          item.variances = this._.uniqBy(item.variances, 'store_number')
          return item
        })
        this.items = uniqueitems
        this.expanded = this.items.filter(o1 =>
          expanded.some(o2 => o1.upc === o2.upc)
        )
        this.$store.commit('SET_ADDED_ITEMS', uniqueitems)
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error Retrieving Items'
        })
      } finally {
        this.$store.dispatch('setOverlay', { status: 'hide ${expanded}' })
      }
    },

    getSelectedVariancesByZone() {
      if (this.selected.length && this.selectedPriceZones.length) {
        const allSelectedVariances = this.selected.reduce((acc, item) => {
          const variances = item.variances
          acc.push(...variances)
          return acc
        }, [])
        const variancesByZone = allSelectedVariances.reduce((acc, variance) => {
          this.selectedPriceZones.map(priceZone => {
            if (priceZone.code == variance.price_zone) {
              acc.push(variance)
            }
          })
          return acc
        }, [])
        this.selectedVariances = variancesByZone
        this.priceZoneSelectMenu = false
      }
    },

    getSelectedVariancesByStore() {
      if (this.selected.length && this.selectedStores.length) {
        const allSelectedVariances = this.selected.reduce((acc, item) => {
          const variances = item.variances
          acc.push(...variances)
          return acc
        }, [])
        const variancesByStore = allSelectedVariances.reduce(
          (acc, variance) => {
            this.selectedStores.map(store => {
              if (store.store_number == variance.store_number) {
                acc.push(variance)
              }
            })
            return acc
          },
          []
        )
        this.selectedVariances = variancesByStore
        this.storeSelectMenu = false
      }
    },

    async addItems(payload) {
      this.saving = true
      const { newItem, data } = payload
      newItem ? this.items.push(data) : this.items.push(...data)

      const uniqueitems = this.items.map(item => {
        item.variances = this._.uniqBy(item.variances, 'store_number')
        return item
      })

      try {
        await this.$items.saveItems(this.contract.contract_uuid, uniqueitems)
        await this.getItems()
        this.$store.dispatch('setSnackbar', {
          status: 'success',
          text:
            payload.length > 1
              ? 'Items Added to Contract'
              : 'Item Added to Contract'
        })
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error Saving Items'
        })
      } finally {
        this.saving = false
        this.getItems()
      }
    },

    async updateItems(payload) {
      this.$store.dispatch('setOverlay', {
        status: 'show',
        text: 'Updating...'
      })
      let selectedItems = this.selected
      if (typeof payload === 'object') {
        const {
          updateObject,
          genCurrencyToPercent,
          adCurrencyToPercent,
          tprCurrencyToPercent,
          includeStores,
          prePriced,
          costChange,
          pricingRules
        } = payload

        this.selectedVariances.map(variance => {
          for (const key in updateObject) {
            if (key && updateObject[key]) {
              variance[key] = updateObject[key]
            }
          }

          updateObject.regular_retail && genCurrencyToPercent
            ? (variance.regular_conversion = 'dollar_to_percent')
            : updateObject.regular_retail_percentage && !genCurrencyToPercent
            ? (variance.regular_conversion = 'percent_to_dollar')
            : (variance.regular_conversion = null)

          updateObject.tpr_retail && tprCurrencyToPercent
            ? (variance.tpr_conversion = 'dollar_to_percent')
            : updateObject.tpr_retail_percentage && !tprCurrencyToPercent
            ? (variance.tpr_conversion = 'percent_to_dollar')
            : (variance.tpr_conversion = null)

          updateObject.ad_retail && adCurrencyToPercent
            ? (variance.ad_conversion = 'dollar_to_percent')
            : updateObject.ad_retail_percentage && !adCurrencyToPercent
            ? (variance.ad_conversion = 'percent_to_dollar')
            : (variance.ad_conversion = null)

          if (pricingRules !== 'null') {
            variance.pricing_rules = pricingRules
          }
          if (includeStores !== 'null') {
            variance.included_flag = includeStores
          }
          if (prePriced !== 'null') {
            variance.pre_priced = prePriced
          }
          if (costChange !== 'null') {
            variance.cost_change = costChange
          }
        })
      }

      const uniqueitems = this.items.map(item => {
        item.variances = this._.uniqBy(item.variances, 'store_number')
        return item
      })

      try {
        await this.$items.saveItems(this.contract.contract_uuid, uniqueitems)
        this.modal = false
        this.$store.dispatch('setSnackbar', {
          status: 'success',
          text: 'Contract Items Updated'
        })
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error Updating Items'
        })
      } finally {
        this.$store.dispatch('setOverlay', { status: 'hide' })
        await this.getItems()
        this.selected = this._.intersectionBy(this.items, selectedItems, 'upc')
      }
    },

    async removeItems() {
      this.$store.dispatch('setOverlay', {
        status: 'show',
        text: 'Removing...'
      })
      const count = this.selected.length
      this.items = this._.differenceBy(this.items, this.selected, [
        'upc',
        'item_exists'
      ])
      try {
        await this.$items.saveItems(this.contract.contract_uuid, this.items)
        this.$store.commit('SET_ADDED_ITEMS', this.items)
        this.$store.dispatch('setSnackbar', {
          status: 'success',
          text: count.length > 1 ? `${count} Items Removed` : 'Item Removed'
        })
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error Removing Items'
        })
      } finally {
        this.selectedPriceZones = []
        this.selectedStores = []
        this.selected = []
        this.$store.dispatch('setOverlay', { status: 'hide' })
        this.modal = false
      }
    }
  }
}
</script>
<style scoped>
.itemSelect {
  background-color: #e4effa !important;
  color: #1976d2 !important;
}
th.text-end {
  z-index: inherit;
}

.noWrap {
  white-space: nowrap;
}

.v-data-table-header th {
  white-space: nowrap;
}
</style>
